module.exports = __webpack_public_path__ + "static/pinturas-4.e28f8e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/pinturas-4.jpg
// module id = 156
// module chunks = 48515692054781 250387718087078